export default {
    ELEMENT_RECEIVED: 'ELEMENT_RECEIVED',
    ELEMENT_CHANGING: 'ELEMENT_CHANGING',           // When changes are being made (x, y, data, anything...)
    ELEMENT_REMOVED:  'ELEMENT_REMOVED',
    ELEMENT_BROUGHT_FORWARD:  'ELEMENT_BROUGHT_FORWARD',
    ELEMENT_SENT_BACKWARD:  'ELEMENT_SENT_BACKWARD',
    ELEMENT_BROUGHT_TO_FRONT:  'ELEMENT_BROUGHT_TO_FRONT',
    ELEMENT_SENT_TO_BACK:  'ELEMENT_SENT_TO_BACK',
};
